import { createAction, props } from '@ngrx/store';

import { HiringManagerAggregation } from '@shared';

export const jobHiringManagerCandidatesLoad = createAction(
  '[Job Page] Hiring Manager Candidates Load',
  props<{ params: { offset?: number; status?: string; sort?: string } }>(),
);

export const jobCandidatesInReviewLoadSuccess = createAction(
  '[Job Page] Hiring Manager Candidates In Review Load Success',
  props<{ payload: HiringManagerAggregation; jobId: number }>(),
);

export const jobCandidatesAdvancedLoadSuccess = createAction(
  '[Job Page] Hiring Manager Candidates Advanced Load Success',
  props<{ payload: HiringManagerAggregation; jobId: number }>(),
);

export const jobCandidatesRejectedLoadSuccess = createAction(
  '[Job Page] Hiring Manager Candidates Rejected Load Success',
  props<{ payload: HiringManagerAggregation; jobId: number }>(),
);

// assume optimistically list item removal is successful (animation)
// otherwise rollback changes by refreshing
export const jobHiringManagerRemoveItemLocallyInReview = createAction(
  '[Job Page] Hiring Manager Remove Item Locally In Review',
  props<{ candidateId: number }>(),
);

export const jobHiringManagerRemoveItemLocallyAdvanced = createAction(
  '[Job Page] Hiring Manager Remove Item Locally Advanced',
  props<{ candidateId: number }>(),
);

export const jobHiringManagerRemoveItemLocallyRejected = createAction(
  '[Job Page] Hiring Manager Remove Item Locally Rejected',
  props<{ candidateId: number }>(),
);
